import React from "react";
import UserCard from "./UserCard";
import "./UserCards.css";

const UserCards = ({ data, onCardClick }) => {
  return (
    <div className='usercards'>
      {data &&
        data.sort((a, b) => a.active - b.active).map((user) => <UserCard user={user} onCardClick={onCardClick} />)}
    </div>
  );
};

export default UserCards;
